import Vue from 'vue'
import store from './store'
import router from './router'
import App from './components/App'
import ElementUI from 'element-ui';
// 引入aos
import AOS from 'aos';
import 'aos/dist/aos.css';
import 'element-ui/lib/theme-chalk/index.css';
//这里的Vue要做修改，等会就知道了
Vue.use(ElementUI);
// 使用AOS插件
AOS.init();

new Vue({
  router,
  store,
  template: '<App/>',
  components: { App }
}).$mount('#app')
 


// WEBPACK FOOTER //
// ./src/main.js